export default __webpack_public_path__ + "static/media/scissors.3a01fdfe.png";